import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import useDerivedStateFromProps from '@elliemae/ds-utilities/hooks/useDerivedStateFromProps';
import { parsePerPageNumber } from './helper.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function usePaginationState(grid) {
  var _grid$props = grid.props,
      _grid$props$minPerPag = _grid$props.minPerPage,
      minPerPage = _grid$props$minPerPag === void 0 ? 0 : _grid$props$minPerPag,
      _grid$props$maxPerPag = _grid$props.maxPerPage,
      maxPerPage = _grid$props$maxPerPag === void 0 ? 50 : _grid$props$maxPerPag,
      _grid$props$onPerPage = _grid$props.onPerPageChange,
      onPerPageChange = _grid$props$onPerPage === void 0 ? function () {
    return null;
  } : _grid$props$onPerPage,
      _grid$props$onPageCha = _grid$props.onPageChange,
      onPageChange = _grid$props$onPageCha === void 0 ? function () {
    return null;
  } : _grid$props$onPageCha,
      _grid$props$paginatio = _grid$props.pagination,
      paginationProp = _grid$props$paginatio === void 0 ? {
    page: 1,
    perPage: 10
  } : _grid$props$paginatio,
      groupedRows = _grid$props.groupedRows;

  var _grid$getInstance = grid.getInstance(),
      composedRows = _grid$getInstance.composedRows,
      rows = _grid$getInstance.rows;

  var _useDerivedStateFromP = useDerivedStateFromProps(paginationProp),
      _useDerivedStateFromP2 = _slicedToArray(_useDerivedStateFromP, 2),
      pagination = _useDerivedStateFromP2[0],
      setPagination = _useDerivedStateFromP2[1];

  var onPerPage = function onPerPage(perPageNumber) {
    var parsedPerPageNumber = parsePerPageNumber(perPageNumber, maxPerPage, minPerPage);
    var actualNumber = parsedPerPageNumber ? parseInt(parsedPerPageNumber, 10) : 0;
    setPagination(function (prevPagination) {
      onPerPageChange(actualNumber);
      return {
        page: prevPagination.page,
        perPage: actualNumber
      };
    });
  };

  var onPageSelect = function onPageSelect(page) {
    var length = groupedRows ? composedRows.length : rows.length;
    setPagination(function (prevPagination) {
      var pages = Math.ceil(length / prevPagination.perPage);
      onPageChange(page);
      return _objectSpread(_objectSpread({}, prevPagination), {}, {
        page: Math.min(Math.max(page, 1), pages)
      });
    });
  };

  return {
    state: {
      pagination: pagination
    },
    actions: {
      onPerPage: onPerPage,
      onPageSelect: onPageSelect
    }
  };
}

export { usePaginationState };
//# sourceMappingURL=usePaginationState.js.map
